/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Embedding_QueuedInputs */



/**
* | output |
* | --- |
* | "{count} files queued for embedding" |
*
* @param {Spaces_Embedding_QueuedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_queued = /** @type {((inputs: Spaces_Embedding_QueuedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_QueuedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Dateien zur Einbettung eingereiht`)
	return /** @type {LocalizedString} */ (`${i?.count} files queued for embedding`)
});